import React from "react"
import "./css/Header.css"
import "./css/About.css"
import aboutimage from "../assets/aboutphoto.jpeg"
import location from "../assets/location.png"
import img1220 from "../assets/1220.jpg"
import img0845 from "../assets/0845.jpg"
import img0982 from "../assets/0982.jpg"
import img1053 from "../assets/1053.jpg"

const About = () => {
  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">About Jambo Tree Kenya</h1>
            <p className="page-subtitle">
              An innovative, women-led initiative providing Nature-based solutions to address climate change
            </p>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="about-intro-section">
        <div className="container">
          <div className="about-intro-content">
            <div className="about-text-content">
              <h2 className="section-title">Who are we and what we do?</h2>
              <div className="title-underline"></div>
              
              <div className="content-block">
                <p className="lead-text">
                  Jambo Tree was set up in 2017, as an innovative, women-led initiative that provides Nature-based solutions that seek to help address climate change by cultivating indigenous African tree seedlings and supplying to local & worldwide export markets.
                </p>
                
                <p className="body-text">
                  Jambo Tree Consultancy services in Carbon markets & ESG offer transformative change across policy, technology, finance, and community behaviour. By aligning with Article 6 of the Paris Agreement, and the UN Sustainable Development Goals, we offer organizations support and advice that promotes sustainable economic growth while addressing the urgent need to mitigate climate change.
                </p>
                
                <p className="body-text">
                  Our farm, located at the foot of Mount Kilimanjaro in the Kimana, Loitoktok area of Kajiado County, Kenya, cultivates African indigenous tree varieties including Acacia and Adansonia (Baobab) seeds, seedlings and trees, which are drought tolerant and require low maintenance once they are established.
                </p>
              </div>
            </div>
            
            <div className="about-images-section">
              <div className="main-image">
                <img src={aboutimage} alt="Jambo Tree Kenya team at work" />
              </div>
              <div className="image-grid">
                <img src={img1220} alt="Tree cultivation work" />
                <img src={img0845} alt="Seedling preparation" />
                <img src={img0982} alt="Field operations" />
                <img src={img1053} alt="Tree nursery" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="location-section">
        <div className="container">
          <div className="location-content">
            <div className="location-text">
              <h2 className="section-title">Where is Jambo Tree Kenya located?</h2>
              <div className="title-underline"></div>
              <p className="body-text">
                Jambo Tree Kenya's farm is located at the foot of Mount Kilimanjaro in the Kimana, Loitoktok area of Kajiado County, Kenya. The farm is located in an area inhabited by the indigenous Maasai tribe, and is very near to Amboseli National Park.
              </p>
            </div>
            <div className="location-image">
              <img src={location} alt="Location map of Jambo Tree Kenya" />
            </div>
          </div>
        </div>
      </section>

      {/* Consultancy Services Section */}
      <section className="consultancy-section">
        <div className="container">
          <h2 className="section-title">Our Consultancy Services</h2>
          <div className="title-underline"></div>
          
          <div className="consultancy-content">
            <p className="lead-text">
              Jambo Tree offers climate action innovation, driving transformative change across policy, technology, finance, and community behaviour. We offer organizations support and advice that promotes sustainable economic growth while addressing the urgent need to mitigate climate change such as:
            </p>
            
            <div className="services-list">
              <div className="service-item">
                <h4>Carbon Project Development</h4>
                <p>Expert guidance in implementing projects that avoid, reduce, or remove GHG emissions. Our comprehensive approach encompasses initial design, feasibility studies, stakeholder engagement, carbon policy frameworks, monitoring, verification, and access to carbon markets.</p>
              </div>
              <div className="service-item">
                <h4>Green Audits & Sustainability Reporting</h4>
                <p>Systematic evaluation of operations to assess environmental impact and ESG analysis. We provide operational streamlining, legislative compliance, waste reduction, and foundation for environmental management systems and ISO certifications.</p>
              </div>
              <div className="service-item">
                <h4>GHG Emissions - Carbon Calculation</h4>
                <p>Comprehensive carbon footprint measurement including corporate footprint reporting (Scope 1, 2 & 3), life cycle assessment, carbon modelling, and public reporting to support net-zero emissions and decarbonization.</p>
              </div>
              <div className="service-item">
                <h4>Climate Risk & Adaptation</h4>
                <p>High-level services to assess climate risks and support adaptation, mitigation & resilience strategies. We develop solution responses and create roadmaps for mobilizing climate protection for people, economy, and natural ecosystems.</p>
              </div>
              <div className="service-item">
                <h4>Agro-Forestry - Tree Planting Services</h4>
                <p>Indigenous tree seedling cultivation from our state-of-the-art nursery in Oloitoktok, Kenya. We support climate mitigation projects, CSR activities, CO2 offsetting, and provide nursery construction and management training.</p>
              </div>
              <div className="service-item">
                <h4>Capacity Building & Training</h4>
                <p>Comprehensive training programs on Carbon Markets, ESG reporting, Environmental Impact Assessment, sustainability principles, and practical applications. We equip senior officials and staff with necessary skills for environmental decision-making.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="projects-section">
        <div className="container">
          <h2 className="section-title">Our Projects</h2>
          <div className="title-underline"></div>
          
          <div className="projects-intro">
            <p className="lead-text">
              Our global experience in working on sustainability projects in the UK, Brazil, UAE, Kenya and Somalia, enables us to provide analysis & create strategies for mobilization of climate finance and Carbon markets trading. We foster collaborations and partnerships between different stakeholders in the <strong>"Green Space"</strong>
            </p>
          </div>

          <div className="project-timeline">
            <div className="timeline-item">
              <div className="timeline-date">2025</div>
              <div className="timeline-content">
                <h3 className="carbon-markets-title">Carbon Markets Assessment for Kenya</h3>
                <p>
                  A highly competitive tender commissioned by the Capital Markets Authority, Treasury, Government of Kenya. We beat major firms like KPMG & Ernst & Young with a 92% technical score. This project involved scoping, quantifying and assessing the size of Kenya's Carbon Markets Ecosystem, stakeholder identification, mapping and assessment, carbon market's structure analysis and review of legal and regulatory frameworks ensuring full integration of Paris Agreement, UNFCCC, IPCC and Climate Change Act 2016 requirements.
                </p>
                <div className="project-tags">
                  <span className="tag">Government Commission</span>
                  <span className="tag">92% Technical Score</span>
                  <span className="tag">Beat KPMG & EY</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-date">2023</div>
              <div className="timeline-content">
                <h3>Environmental Management System - Brazil Ports</h3>
                <p>
                  Designing an Environmental Management System (EMS) for Porte Alegre & Rio Grande Ports. Evaluation & auditing of Blue Economy projects around the Ports, by effective analytics, technical testing and monitoring of CO2 emissions and sequestrations, surface water and leachate monitoring, and implementation of Green Shipping Corridor partnerships.
                </p>
                <div className="project-tags">
                  <span className="tag">Blue Economy</span>
                  <span className="tag">Green Shipping Corridors</span>
                  <span className="tag">Port Systems</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-date">2023</div>
              <div className="timeline-content">
                <h3>Faith & Restoration Program - WWF Kenya</h3>
                <p>
                  Our services included supplying of seedlings, transitioning, advocacy and technical support and training in restoration of community land in the Amboseli landscape. This culminated in the first interfaith collaboration between farmers in the Kajiado South/ Amboseli landscape, leading to the first Green Mosques & churches initiatives and linking farmers to the Voluntary Carbon Markets.
                </p>
                <div className="project-tags">
                  <span className="tag">WWF Partnership</span>
                  <span className="tag">Interfaith Collaboration</span>
                  <span className="tag">Voluntary Carbon Markets</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-date">2022</div>
              <div className="timeline-content">
                <h3>Climate Change Mitigation - Government of Somalia</h3>
                <p>
                  National program on adopting climate change mitigation measures. Provided advice, advocacy in implementing national climate change policies. Spearheaded Mangrove restoration efforts by identifying and sourcing suitable species and building infrastructure such as Tree nurseries, seedbanks.
                </p>
                <div className="project-tags">
                  <span className="tag">Government Program</span>
                  <span className="tag">Mangrove Restoration</span>
                  <span className="tag">National Policy</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-date">2020</div>
              <div className="timeline-content">
                <h3>Green Audit & Sustainability Reporting - Tower Hamlets, London UK</h3>
                <p>
                  Conducted a Carbon Footprint assessment (Scope 1, 2 & 3) and completed a GHG Inventory Report (ISO 14064 standard) for Tower Hamlets Council in London, providing comprehensive sustainability reporting and recommendations for carbon reduction strategies.
                </p>
                <div className="project-tags">
                  <span className="tag">Carbon Footprint</span>
                  <span className="tag">ISO 14064</span>
                  <span className="tag">UK Government</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-date">2018</div>
              <div className="timeline-content">
                <h3>ESG Alignment Program - Desert Group, Dubai UAE</h3>
                <p>
                  Led capacity-building initiatives for partners and stakeholders, facilitating workshops and training to enhance project effectiveness, particularly in areas of ESG, environmental conservation, climate resilience, and sustainable practices in the UAE market.
                </p>
                <div className="project-tags">
                  <span className="tag">ESG Program</span>
                  <span className="tag">Capacity Building</span>
                  <span className="tag">UAE Market</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Learn More?</h2>
            <p>Explore our services, view our products, or get in touch to discuss how we can work together.</p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">Work With Us</a>
              <a href="/contact" className="btn btn-outline">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About